import {
  CustomVariable,
  CreateCustomVariablePayload,
  UpdateCustomVariablePayload,
} from '@/types/api';
import { getApiBaseUrl, handleResponse } from './client';

export async function getCustomVariables(): Promise<CustomVariable[]> {
  const response = await fetch(`${getApiBaseUrl()}/custom-variables`);
  return handleResponse<CustomVariable[]>(response);
}

export async function createCustomVariable(
  payload: CreateCustomVariablePayload,
): Promise<CustomVariable> {
  const response = await fetch(`${getApiBaseUrl()}/custom-variables`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<CustomVariable>(response);
}

export async function updateCustomVariable(
  id: string,
  payload: UpdateCustomVariablePayload,
): Promise<CustomVariable> {
  const response = await fetch(`${getApiBaseUrl()}/custom-variables/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<CustomVariable>(response);
}

export async function deleteCustomVariable(id: string): Promise<void> {
  const response = await fetch(`${getApiBaseUrl()}/custom-variables/${id}`, {
    method: 'DELETE',
  });
  await handleResponse<void>(response);
}

export async function reorderCustomVariables(orderedIds: string[]): Promise<void> {
  const response = await fetch(`${getApiBaseUrl()}/custom-variables/reorder`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(orderedIds),
  });
  await handleResponse<void>(response);
}